import React from "react";
import { currentWindow } from "./Countdown";

export function PreorderBadge({ className = "" }) {
  return (
    <span
      data-testid="preorder-badge"
      className={`inline-flex items-center gap-1.5 bg-yellow-400 text-black font-mono font-bold text-[10px] px-2 py-1 uppercase tracking-widest rounded-sm ${className}`}
      style={{ boxShadow: "0 0 12px rgba(250,204,21,0.3)" }}
    >
      Winter '26
    </span>
  );
}

export function PreorderInfo() {
  const w = currentWindow();
  if (!w) return <div data-testid="preorder-info" className="text-xs font-mono text-zinc-400">ORDER WINDOW CLOSED</div>;
  return (
    <div data-testid="preorder-info" className="text-xs font-mono text-zinc-400 space-y-0.5">
      <div>
        ORDER WINDOW CLOSES: <span className="text-yellow-400">{w.label.toUpperCase()}</span>
      </div>
      <div data-testid="preorder-delivery-note">{w.note.toUpperCase()}</div>
    </div>
  );
}
